import type SubscriptionType from '@/generated/classes/SubscriptionType';

export interface SubscriptionDeclarationInformation {
  month: string;
  customerCode: number;
  companyName: string;
}

export interface SubscriptionCompletion {
  subscriptionType: SubscriptionType;
  declarationInformation: SubscriptionDeclarationInformation | null;
  completed: boolean;
}

export function declarationContactUrl(information: SubscriptionDeclarationInformation): string {
  const subject = 'Demande de démarrage anticipé de mes déclarations sociales';
  const body = [
    'Bonjour,',
    '',
    `Code client : ${information.customerCode}`,
    `Raison sociale : ${information.companyName}`,
    '',
    `Je souhaite que Ovatio démarre mes déclarations sociales avant ${information.month}, date actuellement prévue.`,
    'Date de démarrage souhaitée : ',
    '',
    'Merci de me recontacter pour étudier ma demande.',
    'Cordialement,',
  ].join('\r\n');

  return `mailto:info@cheque-intermittents.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
